import { render } from "./MyTeamView.vue?vue&type=template&id=16c459d5"
import script from "./MyTeamView.vue?vue&type=script&lang=js"
export * from "./MyTeamView.vue?vue&type=script&lang=js"

import "./MyTeamView.vue?vue&type=style&index=0&id=16c459d5&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__